<script setup lang="ts">
import { enUS } from 'date-fns/locale'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useTaskCreationPickerDeadline } from '../../model/task-creation-picker-deadline.hook'

defineOptions({
  name: 'TaskCreationPickerDeadline',
})

const {
  refDate,
  refStartTime,
  refMinDate,
  refStageAge,
  refIsError,
  handleChange,
} = useTaskCreationPickerDeadline()
</script>

<template>
  <div :class="['task-creation-picker-deadline', { error: refIsError }]">
    <Datepicker
      v-model="refDate"
      :min-date="refMinDate"
      :locale="enUS"
      :week-start="1"
      :formats="{ input: 'MMM dd, yyyy HH:mm' }"
      :start-time="refStartTime"
      :clearable="true"
      :time-config="{ timePickerInline: true }"
      placeholder="Select date"
      :teleport-center="true"
      @update:model-value="handleChange"
    >
      <template #input-icon>
        <IconContainer>
          <FontAwesomeIcon :icon="faClock" />
        </IconContainer>
      </template>
      <template #clock-icon>
        <IconContainer>
          <FontAwesomeIcon :icon="faClock" />
        </IconContainer>
      </template>
    </Datepicker>
    <AppText
      v-if="refStageAge"
      name="body2"
      color="slate-500"
      class="task-creation-picker-deadline__age"
    >
      Card age: {{ refStageAge }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./TaskCreationPickerDeadline.scss" />
